interface UnknownObject {
  [x: string]: any;
}

/**
 * Return the value when it is already an array, otherwise an empty array.
 * Guards `.map`/`.reduce`/`.forEach` call sites against values that arrive as
 * undefined, null, or a non-array shape from upstream data.
 */
export function ensureArray<T = unknown>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}

export class ArrayUtils {
  static mapEntitiesToIds = (entities: UnknownObject[]) => {
    return entities.map((entity) => entity.id);
  };

  static reduceArrayToObject = (array: UnknownObject[], targetKey = 'id') => {
    return array.reduce(
      (acc, entity) => ({ ...acc, [entity[targetKey]]: entity }),
      {}
    );
  };
}
